import React from 'react';

import { buildFilter } from '../utils/sqlUtils';
import {checkFieldTypeWarning} from "../utils/genericUtils";

const FilterPreviewer = props => {
  const sql = options => {
    return buildFilter(options);
  };

  return (
    <div>
      <pre style={{ whiteSpace: 'pre-line' }}>{sql(props.options)}</pre>
      {props?.options?.fieldWarnings?.map((warn, index) => (
          <div key={index}>{checkFieldTypeWarning(props.options?.sets, warn?.fieldType, warn?.warningMessage)}</div>
      )) ?? ''}
    </div>
  );
};

export default FilterPreviewer;
